import CoreuiController from "../lib/coreui-controller"
import Rating from "../coreui/rating"

export default class CoreuiRatingController extends CoreuiController {
  static Component = Rating
}
